<template>
  <active-button
    class="menu-item"
    :active="active"
    @click="$emit('click')"
  >
    <sport-icon-liga-white :name="sport.alias" style="margin-left: 2px; margin-top: -2px;" />
    <span class="count-events">{{ sport.events.length }}</span>
    <span>{{ sport.name }}</span>
  </active-button>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'

export default {
  components: { ActiveButton, SportIconLigaWhite },
  props: {
    active: Boolean,
    sport: Object
  }
}
</script>

<style scoped>
.menu-item { align-items: center; height: 50px; display: flex; flex-direction: column; flex-shrink: 0; justify-content: center; /* padding: 0 10px; */ flex: 1 0; }
.menu-item .sport-icon { margin: 3px 0; }
</style>
<style scoped>
.count-events { z-index: 1;
    margin-top: -30px;
    position: absolute;
    margin-left: 36px;
    font-weight: 700;
    font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/components/live/overview/MenuItem.vue